<template>
  <div>
    <h3 v-if="!recuperation" class="mb-3">Confirmation de Compte</h3>
    <h3 v-if="recuperation" class="mb-3">Modification de mot de passe</h3>
    <b-form @submit.prevent="handleSubmit">
      <div class="alert alert-danger" v-show="errors.any()">
        <div v-if="errors.has('password')">
          {{ errors.first("password") }}
        </div>
        <div v-if="errors.has('password_confirmation')">
          {{ "Les mots de passe ne correspondent pas" }}
        </div>
      </div>
      <b-form-group
        id="password-group"
        label="Mot de passe"
        label-for="password"
      >
        <input
          ref="password"
          type="password"
          v-model="payload.password"
          name="password"
          class="form-control"
          placeholder="Password"
          v-validate="'required|verify_password'"
        />
      </b-form-group>

      <b-form-group
        id="password-confirmation-group"
        label="Confirmation du mot de passe"
        label-for="password_confirmation"
      >
        <input
          type="password"
          name="password_confirmation"
          v-model="payload.password_confirm"
          class="form-control"
          placeholder="confirmation mot de passe"
          v-validate="'required|confirmed:password'"
        />
      </b-form-group>

      <b-button type="submit" variant="primary">Confirmer</b-button>
    </b-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    recuperation: Boolean
  },
  data () {
    return {
      payload: {
        password: '',
        password_confirm: '',
        token: this.$route.params.token
      }
    }
  },
  created () {
    this.$validator.extend('verify_password', {
      getMessage: field => `Le mot de passe doit être alphanumérique d' au minimum 8 caractères, avec au minimum une majuscule et un chiffre.`,
      validate: value => {
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
        return strongRegex.test(value)
      }
    })
  },
  methods: {
    ...mapActions(['confirmationUser', 'recuperationPassword']),
    handleSubmit () {
      if (!this.recuperation) {
        this.confirmationUser(JSON.stringify(this.payload)).then((res) => {
          this.$toaster.success('Compte confirmé')
          this.$router.push('../login')
        }, (err) => {
          this.$toaster.error(err)
        })

        return
      }

      this.recuperationPassword(JSON.stringify(this.payload)).then((res) => {
        this.$toaster.success('MdP modifié')
        this.$router.push('../login')
      }, (err) => {
        this.$toaster.error(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/confirmationForm/index.vue